import React from "react";
import {
  CalendarLinkText,
  CalendarText,
  EmptyDashboard,
  NotFound,
} from "./EmptyDashboard.styles";
import { notFound } from "../../../../public/assets";

interface Props {
  titleText: string;
  subtitleText?: string;
  specialStyle?: boolean;
}

const EmptyDashBoard = ({
  titleText,
  subtitleText,
  specialStyle = false,
}: Props) => {
  return (
    <EmptyDashboard>
      <NotFound src="/assets/svg/Not_Found_illustration.png" />
      <CalendarLinkText specialStyle={specialStyle}>
        {titleText}
      </CalendarLinkText>
      <CalendarText>{subtitleText}</CalendarText>
    </EmptyDashboard>
  );
};

export default EmptyDashBoard;
